import { gql } from '@apollo/client'

const DOCUMENT_DETAILS_FRAGMENT = gql`
    fragment DocumentFragment on Document{
        id
        job_id
        job_detail_id
        document_key
        document_url
        file_name
        upload_date
        document_tags {
            id
            name
            is_active
        }
        file_type
}`

const DOCUMENT_QUERY = gql`
    ${DOCUMENT_DETAILS_FRAGMENT}
    query documentTreeQuery ($job_id: ID!) {
        documents(job_id: $job_id){
         ...DocumentFragment
        }
    }
`

const GET_PRESIGN = gql`
    mutation GetPresign ($key: String!, $contentType: String) {
        presign(key: $key, contentType: $contentType) {
                url
        }
    }
`


const INSERT_DOCUMENT = gql`
    mutation InsertDocuments($documents: DocumentUpload!) {
        insertDocuments(documents: $documents) {
         ...DocumentFragment
        }
    }
    ${DOCUMENT_DETAILS_FRAGMENT}
`

const RENAME_FILE = gql`
    mutation RenameDocument ($document_id: ID!, $job_id: ID!, $newName: String!) {
        renameDocument(document_id: $document_id, job_id: $job_id, newName: $newName){
            id
        }
    }
`

const REMOVE_DOCUMENT_MUTATION = gql`
    mutation RemoveDocument($id: ID!, $documentKey: String!, $jobId: String!) {
        removeDocument(id: $id, documentKey:$documentKey, jobId: $jobId) {
         ...DocumentFragment
        }
    }
    ${DOCUMENT_DETAILS_FRAGMENT}
`

const ADD_DOCUMENT_TAG = gql`
    mutation AddDocumentTag ($documentId: ID!, $tagId: ID!) {
        addDocumentTag(documentId: $documentId, tagId: $tagId) {
            documentId
            upload_date
        }
    }
`

const REMOVE_DOCUMENT_TAG = gql`
    mutation RemoveDocumentTag ($documentId: ID!, $tagId: ID!) {
        removeDocumentTag(documentId: $documentId, tagId: $tagId) {
            documentId
            upload_date
        }
    }
`

export { DOCUMENT_DETAILS_FRAGMENT, DOCUMENT_QUERY, GET_PRESIGN, INSERT_DOCUMENT, RENAME_FILE, REMOVE_DOCUMENT_MUTATION, ADD_DOCUMENT_TAG, REMOVE_DOCUMENT_TAG }